<template>
   <div class="diagnostic-graph">
     <ul class="content-diagnostic-graph">
       <li class="list-diagnostic-graph"
           v-for="(diagnostic, indexDiagnostic) in diagnostics"
           :key="indexDiagnostic"
           :style="`width:${diagnostic.percentage}%`">
         <div class="pointer" :style="`background-color:${colors[indexDiagnostic]};`"
              @click.prevent="selectDiagnostic(diagnostic)" :id="`tooltip-target-${indexDiagnostic}`">
          <span>
              {{ diagnostic.code }}
          </span>
         </div>
         <b-tooltip :target="`tooltip-target-${indexDiagnostic}`" triggers="hover">
           <div class="text-code">
             {{ diagnostic.code }}
           </div>
           <div class="text-name">
             {{ diagnostic.name }}
           </div>
           <div class="text-percentage">
             {{diagnostic.percentage}}%
           </div>
         </b-tooltip>
       </li>
     </ul>
   </div>
</template>

<script>

export default {
  props: {
    diagnostics: []
  }
  ,data (){
      return{
       colors: [
          "#E63D78",
          "#000186",
          "#9681FF",
          "#B039CE",
          "#F3A3BF",
          "#E63D78",
          "#000186",
          "#9681FF",
          "#B039CE",
          "#F3A3BF",
          "#59A5FF",
          "#1719DA",
          "#53BE6B",
          "#8D00A5",
          "#B039CE",
          "#3713C7",
          "#0075FF",
          "#004BD1",
          "#59A5FF",
          "#1719DA",
          "#53BE6B",
          "#8D00A5",
          "#B039CE",
          "#3713C7",
          "#0075FF",
          "#004BD1",
          "#59A5FF",
          "#E63D78",
          "#000186",
          "#9681FF"
        ],
      }
  }
  ,methods : {
    selectDiagnostic ({ id })
    {
      this.$emit('clicked:diagnostic', id)
    }
  }
}
</script>

<style lang="scss">
.diagnostic-graph {
  .content-diagnostic-graph {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    align-content: flex-end;
    padding: 0;
    margin-top: 15px;
    .list-diagnostic-graph{
      display: inline-flex;
      width: auto;
      min-width: 60px;
      min-height: 115px;
      div{
        width: 100%;
        display: inline-flex;
        align-items: flex-end;
        justify-content: flex-end;
        color: #FFFFFF;
      }
    }

  }
}
.text-code{
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
}
.text-name{
  font-weight: 500;
}
.text-percentage{
  font-weight: 500;
  font-size: 1.2rem;
}
</style>